module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-ru-1.75bf01e6.png";